import { gql } from 'graphql-request';

export const QUERY_PLACES_SEARCH = gql`
  query PlacesSearch($placeTermInput: PlaceTermInput!) {
    # HC CAPABILITY: platform-search-experience
    # HC CAPABILITY: pexp-product-access
    # HC CAPABILITY: market-insights-product-access
    searchPlace(id: $placeTermInput) {
      places {
        __typename
        description
        placeId
        placeType
        location {
          latitude
          longitude
        }
        viewport {
          northeastLatitude
          northeastLongitude
          southwestLatitude
          southwestLongitude
        }
      }
      addresses {
        __typename
        hcAddressId
        fields {
          hcBuildingId
          count
          fullLine
          hasAvm
          isUnit
          latitudeLongitude
          partialLine
          slug
        }
      }
    }
  }
`;
